import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia, PiniaVuePlugin } from 'pinia';
import store from './store';
import vuetify from './plugins/vuetify';
import './scss/app.scss';
import './scss/home.scss';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import sanitize from './helpers/sanitizeHelper';
import './plugins/axios';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
} from 'chart.js';

Vue.use(PiniaVuePlugin);
Vue.directive('sanitize', {
    bind: sanitize,
});
const pinia = createPinia();
// Register Chart.js components
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
extend('required', required);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    pinia,
    render: (h) => h(App),
}).$mount('#app');
